import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { VcsAgentConnectionRow } from "../types";

const VCSAgentPoolAgentsTableAgentIdCell = ({
  item: agentConnection,
  ...cellProps
}: TableSimpleCellProps<VcsAgentConnectionRow>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{agentConnection.id}</TableCellText>
    </TableSimpleCell>
  );
};

export default VCSAgentPoolAgentsTableAgentIdCell;
